import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { BG_GRADIENT_NEW, COLOR_APP, COLOR_WHITE, WARNING_IMAGE } from "../constants";
import warningImage_purple from "../image/logo_main.png";

export default function ModalConfirmComponent({
  showConfirmModal,
  handleCancel,
  handleConfirm,
  loadingConfirm,
  title,
  text,
}) {
  return (
    <Modal
      show={showConfirmModal}
      // onHide={handleCancel}
      backdrop="static"
      centered
      zIndex={9999}
      keyboard={false}>
      <Modal.Body>
        <div
          style={{
            width: "100%",
            height: "12em",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}>
          <img
            src={warningImage_purple}
            style={{
              width: "5em",
              height: "5em",
              marginBottom: "1em",
            }}
            alt="wninngImage"
          />
          <h4>{title ?? "ແຈ້ງເຕືອນ"}</h4>
          <p>{text}</p>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
        }}>
        <Button variant="outline-secondary" style={{ borderRadius: 6, width: 100 }} onClick={handleCancel}>
          ຍົກເລິກ
        </Button>
        <Button
          style={{
            background: BG_GRADIENT_NEW,
            color: COLOR_WHITE,
            border: "none",
            borderRadius: 6,
            width: 100
          }}
          onClick={handleConfirm}>
          {loadingConfirm ? <Spinner size="sm" /> : "ຢືນຢັນ"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
